import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_2",
	"data-name": "Layer 2",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 668.98 266.71",
	...props,
	children: [/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: "\n      .cls-1 {\n        fill: #fff;\n        stroke-width: 0px;\n      }\n    " }) }), /* @__PURE__ */ _jsxs("g", {
		id: "Layer_1-2",
		"data-name": "Layer 1",
		children: [
			/* @__PURE__ */ _jsx("rect", {
				className: "cls-1",
				y: 0,
				width: 197.87,
				height: 14.03
			}),
			/* @__PURE__ */ _jsx("rect", {
				className: "cls-1",
				y: 72.27,
				width: 197.87,
				height: 14.03
			}),
			/* @__PURE__ */ _jsx("rect", {
				className: "cls-1",
				y: 144.74,
				width: 197.87,
				height: 14.03
			}),
			/* @__PURE__ */ _jsx("rect", {
				className: "cls-1",
				x: 470.52,
				y: 0,
				width: 197.87,
				height: 14.03
			}),
			/* @__PURE__ */ _jsx("rect", {
				className: "cls-1",
				x: 470.52,
				y: 72.27,
				width: 197.87,
				height: 14.03
			}),
			/* @__PURE__ */ _jsx("rect", {
				className: "cls-1",
				x: 470.52,
				y: 144.74,
				width: 197.87,
				height: 14.03
			}),
			/* @__PURE__ */ _jsx("polygon", {
				className: "cls-1",
				points: "422.56 0 339.42 144.74 328.99 144.74 245.85 0 229.67 0 334.2 182 438.74 0 422.56 0"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "cls-1",
				d: "m180.31,236.85v29.86h37.31v-29.86h-37.31Zm32.95,25.5h-28.59v-21.15h28.59v21.15Z"
			}),
			/* @__PURE__ */ _jsx("polygon", {
				className: "cls-1",
				points: "302.51 266.71 307.78 266.71 307.78 236.85 303.42 236.85 303.42 261 275.72 236.85 270.47 236.85 270.47 266.71 274.82 266.71 274.82 242.56 275.15 242.84 302.51 266.71"
			}),
			/* @__PURE__ */ _jsx("polygon", {
				className: "cls-1",
				points: "128.09 266.71 116.34 255.34 127.5 255.34 127.5 236.85 90.19 236.85 90.19 266.71 94.55 266.71 94.55 241.21 123.15 241.21 123.15 250.99 105.35 250.99 121.8 266.71 128.09 266.71"
			}),
			/* @__PURE__ */ _jsx("polygon", {
				className: "cls-1",
				points: "668.98 266.71 657.23 255.34 668.4 255.34 668.4 236.85 631.09 236.85 631.09 266.71 635.44 266.71 635.44 241.21 664.04 241.21 664.04 250.99 646.24 250.99 662.7 266.71 668.98 266.71"
			}),
			/* @__PURE__ */ _jsx("polygon", {
				className: "cls-1",
				points: "397.93 236.85 360.62 236.85 360.62 241.21 377.33 241.21 377.33 266.71 381.69 266.71 381.69 241.21 397.93 241.21 397.93 236.85"
			}),
			/* @__PURE__ */ _jsx("polygon", {
				className: "cls-1",
				points: "486.3 241.21 486.3 236.85 452.56 236.85 452.56 241.21 467.26 241.21 467.26 262.35 452.56 262.35 452.56 266.71 486.3 266.71 486.3 262.35 471.61 262.35 471.61 241.21 486.3 241.21"
			}),
			/* @__PURE__ */ _jsx("polygon", {
				className: "cls-1",
				points: "578.24 241.21 578.24 236.85 540.93 236.85 540.93 266.71 578.24 266.71 578.24 262.35 545.29 262.35 545.29 253.97 571.46 253.97 571.46 249.62 545.29 249.62 545.29 241.21 578.24 241.21"
			}),
			/* @__PURE__ */ _jsx("polygon", {
				className: "cls-1",
				points: "30.53 249.62 4.36 249.62 4.36 241.21 37.31 241.21 37.31 236.85 0 236.85 0 266.71 4.36 266.71 4.36 253.97 30.53 253.97 30.53 249.62"
			})
		]
	})]
});
export { SvgLogo as ReactComponent };
